import type { Messages } from './messages';
// Per-module message files are imported and spread here. As each module is
// converted (Task 7) it adds one import + one spread entry below. Keys must be
// globally unique (enforced by catalog.test.ts in Task 6).
import { settingsMessages } from '../settings/settings.messages';
import { navMessages } from '../nav/nav.messages';
import { homeMessages } from '../home/home.messages';
import { catalogMessages } from '../catalog/catalog.messages';
import { approvalsMessages } from '../approvals/approvals.messages';
import { actionsMessages } from '../actions/actions.messages';
import { adminMessages } from '../admin/admin.messages';
import { notificationsMessages } from '../notifications/notifications.messages';
import { searchMessages } from '../search/search.messages';
import { securityMessages } from '../security/security.messages';
import { sentryMessages } from '../sentry/sentry.messages';
import { kafkaMessages } from '../kafka/kafka.messages';
import { doraMessages } from '../dora/dora.messages';
import { techInsightsMessages } from '../tech-insights/techInsights.messages';
import { kubernetesMessages } from '../kubernetes/kubernetes.messages';
import { externalToolsMessages } from '../external-tools/externalTools.messages';
import { templatesMessages } from '../templates/templates.messages';
import { configurationMessages } from '../configuration/configuration.messages';
import { helpMessages } from '../help/help.messages';
import { uiMessages } from '../../components/ui/ui.messages';
import { usvcMigrationsMessages } from '../usvcMigrations/usvcMigrations.messages';
import { quicklinksMessages } from '../quicklinks/quicklinks.messages';
import { deploymentsMessages } from '../deployments/deployments.messages';
import { cliAuthMessages } from '../cli-auth/cliAuth.messages';
import { queryMessages } from '../query/query.messages';

export const MESSAGES: Messages = {
  ...settingsMessages,
  ...cliAuthMessages,
  ...navMessages,
  ...homeMessages,
  ...catalogMessages,
  ...approvalsMessages,
  ...actionsMessages,
  ...adminMessages,
  ...notificationsMessages,
  ...searchMessages,
  ...securityMessages,
  ...sentryMessages,
  ...kafkaMessages,
  ...doraMessages,
  ...techInsightsMessages,
  ...kubernetesMessages,
  ...externalToolsMessages,
  ...templatesMessages,
  ...configurationMessages,
  ...helpMessages,
  ...uiMessages,
  ...usvcMigrationsMessages,
  ...quicklinksMessages,
  ...deploymentsMessages,
  ...queryMessages,
};

// Dev guard: catch two modules claiming the same key. Each module added here
// also appends its map to this array.
if (process.env.NODE_ENV !== 'production') {
  const seen = new Set<string>();
  for (const src of [
    settingsMessages,
    navMessages,
    homeMessages,
    catalogMessages,
    approvalsMessages,
    actionsMessages,
    adminMessages,
    notificationsMessages,
    searchMessages,
    securityMessages,
    sentryMessages,
    kafkaMessages,
    doraMessages,
    techInsightsMessages,
    kubernetesMessages,
    externalToolsMessages,
    templatesMessages,
    configurationMessages,
    helpMessages,
    uiMessages,
    usvcMigrationsMessages,
    quicklinksMessages,
    deploymentsMessages,
    queryMessages,
  ]) {
    for (const k of Object.keys(src)) {
      if (seen.has(k)) throw new Error(`[i18n] duplicate message key: ${k}`);
      seen.add(k);
    }
  }
}
